import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'input-phone',
  templateUrl: './input-phone.component.html',
  styleUrls: ['./input-phone.component.css']
})
export class InputPhoneComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() placeholder: string = '';
  @Input() maxlength: number = 15;
  @Input() class: string = 'form-control';

  constructor() { }

}
